import { handleNetworkResponseAndGetJsonAsync, Network } from './Network'
import { GlobalVars } from '../../global'
import { GetExternalDashboardDataResponse } from './collections/dashboard/getExternalDashboardData/getExternalDashboardData_200'
import { GetInternalDashboardDataResponse } from './collections/dashboard/getInternalDashboardData/getInternalDashboardData_200'

export class DashboardManager {
    static _instance: DashboardManager | null = null

    static getManager(): DashboardManager {
        if (this._instance === null) {
            this._instance = new DashboardManager()
        }
        return this._instance
    }

    async getExternalDashboardDataResponse(): Promise<GetExternalDashboardDataResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/dashboard/external`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetExternalDashboardDataResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getInternalDashboardDataResponse(): Promise<GetInternalDashboardDataResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/dashboard/internal`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetInternalDashboardDataResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
}
